import React from "react";

import { Link } from "react-router-dom";

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import NotificationDropdown from '~/components/CommonForBoth/TopbarDropdown/NotificationDropdown';

import logoSimple from "~/assets/images/logo-simple-white.svg";

import ImpersonationAlert from '~/components/CommonForBoth/TopbarDropdown/ImpersonationAlert';
import { useAuth } from '~/context/auth';
import { getUserOwner } from '~/helpers/utilHelper';
import HelpIcon from '~/components/CommonForBoth/TopbarDropdown/HelpIcon';

const Header = () => {

  const { user: authUser } = useAuth();
  const owner = getUserOwner(authUser);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">

            <div className="navbar-brand-box d-lg-none d-md-block px-3">
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSimple} alt="" height="25" className='logo-size-33' />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <h4 className="top-heading">{owner.name}</h4>
          </div>
          <div className="d-flex">
            <ImpersonationAlert />
            <HelpIcon />
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
